import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { teams, account } from '../lib/appwrite';
import './JoinTeam.css';

export default function JoinTeam() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('processing'); // 'processing' | 'success' | 'error'
    const [message, setMessage] = useState('جاري قبول الدعوة...');

    useEffect(() => {
        acceptInvitation();
        // eslint-disable-next-line
    }, []);

    const acceptInvitation = async () => {
        const teamId = searchParams.get('teamId');
        const membershipId = searchParams.get('membershipId');
        const userId = searchParams.get('userId');
        const secret = searchParams.get('secret');

        if (!teamId || !membershipId || !userId || !secret) {
            setStatus('error');
            setMessage('رابط الدعوة غير صالح. تأكد من استخدام الرابط الصحيح من البريد الإلكتروني.');
            return;
        }

        try {
            await teams.updateMembershipStatus(teamId, membershipId, userId, secret);
            setStatus('success');
            setMessage('تم قبول الدعوة بنجاح! سيتم تحويلك الآن...');
            
            // Check if user has an active session now
            try {
                await account.get();
                // User is logged in, redirect to home after short delay
                setTimeout(() => navigate('/home'), 2000);
            } catch {
                // No session, redirect to login
                setTimeout(() => navigate('/login'), 2000);
            }
        } catch (error) {
            console.error('Accept invitation error:', error);
            if (error.code === 409) {
                setStatus('success');
                setMessage('أنت بالفعل عضو في هذا الفريق!');
                setTimeout(() => navigate('/home'), 2000);
            } else {
                setStatus('error');
                setMessage(`فشل قبول الدعوة: ${error.message}`);
            }
        }
    };

    return (
        <div className="join-team-root" dir="rtl">
            <div className="join-team-card">
                <div className={`status-icon ${status}`}>
                    {status === 'processing' && <div className="spinner"></div>}
                    {status === 'success' && <span>✓</span>}
                    {status === 'error' && <span>✕</span>}
                </div>
                <h1>
                    {status === 'processing' && 'جاري المعالجة...'}
                    {status === 'success' && 'تم بنجاح!'}
                    {status === 'error' && 'حدث خطأ'}
                </h1>
                <p>{message}</p>
                {status === 'error' && (
                    <button onClick={() => navigate('/login')} className="go-login-btn">
                        الذهاب لتسجيل الدخول
                    </button>
                )}
            </div>
        </div>
    );
}
